import { useState, useEffect, useRef, useCallback} from 'react';
import { Navigate, useNavigate } from 'react-router-dom';
import Cookies from 'js-cookie';
import { getCookieOptions } from '../utils/cookieUtils';

const SESSION_TIMEOUT = 15 * 60 * 1000; // 15 minutes in milliseconds

const PrivateRoute = ({ children }) => {
  
  
  const [isLoggedIn, setIsLoggedIn] = useState(!!Cookies.get('authData')); 
  const timeoutId = useRef(null);
  const navigate = useNavigate();


  
  const logout = useCallback(() => {
    setIsLoggedIn(false);
    window.location.href = '/logout';
    
  }, []);

  const resetTimer = useCallback(() => {
    if (timeoutId.current) {
      clearTimeout(timeoutId.current);
    }
    timeoutId.current = setTimeout(logout, SESSION_TIMEOUT);
  }, [logout]);

  useEffect(() => {
    if (isLoggedIn) {
      resetTimer(); // Initial timer setup on login
      const handleUserActivity = () => {
        resetTimer();
      };

      // Attach event listeners for user activity
      window.addEventListener('mousemove', handleUserActivity);
      window.addEventListener('keydown', handleUserActivity);
      window.addEventListener('scroll', handleUserActivity);

      // Cleanup event listeners and timer on component unmount
      return () => {
        window.removeEventListener('mousemove', handleUserActivity);
        window.removeEventListener('keydown', handleUserActivity);
        window.removeEventListener('scroll', handleUserActivity);
        if (timeoutId.current) {
          clearTimeout(timeoutId.current);
        }
      };
    }
  }, [isLoggedIn, resetTimer]);

  const authData = Cookies.get('authData');
  //Check member has mutiple ILB or not  
  const multipleIlb = localStorage.getItem('multipleILB');
  const IsCheckedFlag = localStorage.getItem('IsChecked');
  
  // Check if user is trying to access a different carrier URL
  const currentHost = window.location.hostname;
  const owningCarrier = Cookies.get('owningCarrier');
  
  // Extract carrier from hostname (e.g., dev-cigna-member.healthplan.com -> cigna)
  const carrierMatch = currentHost.match(/-(cigna|molina|bcbsaz|sentara|christus|hcsc|mhc)-member\./i);
  const currentCarrier = carrierMatch ? carrierMatch[1].toLowerCase() : null;
  
  // Carrier code mapping
  const carrierCodeMap = {
    'cigna'   : 'CG',
    'molina'  : 'C4',
    'bcbsaz'  : 'Q5',
    'sentara' : 'SY',
    'christus': 'XC',
    'hcsc'    : 'X6',
    'mhc'     : 'M1'
  };
  
  const currentCarrierCode = currentCarrier ? carrierCodeMap[currentCarrier] : null;
  
  // If carrier mismatch detected, clear all cookies and redirect to logout
  if (authData && owningCarrier && currentCarrierCode && owningCarrier !== currentCarrierCode) {
    // Save loginFrom before clearing cookies
    const loginFrom = sessionStorage.getItem('loginFrom');
    // Clear all cookies except lang, owningCarrier, and portal_lang
    const allCookies = Cookies.get();
    const cookieOptions = getCookieOptions();
    Object.keys(allCookies).forEach(cookieName => {
        if (cookieName !== 'lang' && cookieName !== 'owningCarrier' && cookieName !== 'portal_lang') {
            Cookies.remove(cookieName, { ...cookieOptions, path: '/' });
        }
    });
    // Redirect based on saved loginFrom value
    return <Navigate to="/logout" replace />;
    
  }
  
  const skipAuthCheckRoutes = ['/limitedproficiency', '/nondiscrimination', '/contactus', '/glossary', '/faq'];
  const currentPath = window.location.pathname.toLowerCase();
  if (multipleIlb === 'true' && skipAuthCheckRoutes.some((route) => currentPath.endsWith(route))) {
    // If the current route is one of the skipAuthCheckRoutes, don't perform authentication check
    return children; 
  }

  if(!authData) {
    // If not logged in, redirect to the login page
    return <Navigate to="/SlpMember" replace />; 
  }

  if (multipleIlb === 'true' && IsCheckedFlag !== 'true' && !currentPath.endsWith('/landing')) {
    // If logged in but multiple ILB not acknowledged, redirect to the multiple ILB page
    return <Navigate to="/landing" replace />;
  }

  return children; // If logged in and multiple ILB acknowledged, render the children components

  // Make sure to return something!
  //return authData ? children : <Navigate to="/SlpMember" replace />;
};

export default PrivateRoute;